var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D7\\u05D5\\u05D3\\u05E9\\u05D9",
    transform: "translate(-333.000000, -16.000000)",
    fill: "#0091FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-65",
    transform: "translate(315.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apps-24px",
    transform: "translate(18.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.992063492,6.74603175 L6.74603175,6.74603175 L6.74603175,0.992063492 L0.992063492,0.992063492 L0.992063492,6.74603175 Z M9.62301587,24.0079365 L15.3769841,24.0079365 L15.3769841,18.2539683 L9.62301587,18.2539683 L9.62301587,24.0079365 Z M0.992063492,24.0079365 L6.74603175,24.0079365 L6.74603175,18.2539683 L0.992063492,18.2539683 L0.992063492,24.0079365 Z M0.992063492,15.3769841 L6.74603175,15.3769841 L6.74603175,9.62301587 L0.992063492,9.62301587 L0.992063492,15.3769841 Z M9.62301587,15.3769841 L15.3769841,15.3769841 L15.3769841,9.62301587 L9.62301587,9.62301587 L9.62301587,15.3769841 Z M18.2539683,0.992063492 L18.2539683,6.74603175 L24.0079365,6.74603175 L24.0079365,0.992063492 L18.2539683,0.992063492 Z M9.62301587,6.74603175 L15.3769841,6.74603175 L15.3769841,0.992063492 L9.62301587,0.992063492 L9.62301587,6.74603175 Z M18.2539683,15.3769841 L24.0079365,15.3769841 L24.0079365,9.62301587 L18.2539683,9.62301587 L18.2539683,15.3769841 Z M18.2539683,24.0079365 L24.0079365,24.0079365 L24.0079365,18.2539683 L18.2539683,18.2539683 L18.2539683,24.0079365 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.814e4a97667069bcc01d914ed60ac4b0.svg";
export { ForwardRef as ReactComponent };